// the password eye.
import { icon } from './core.ts';

export function initEye(): void {
  document.addEventListener('click', e => {
    const b = (e.target as Element).closest<HTMLElement>('[data-ds-eye]');
    if (!b) return;
    const inp = document.getElementById(b.dataset.dsEye!) as HTMLInputElement,
      show = inp.type === 'password';
    inp.type = show ? 'text' : 'password';
    b.setAttribute('aria-pressed', String(show));
    b.setAttribute('aria-label', show ? 'پنهان کردن رمز' : 'نمایش رمز');
    b.innerHTML = icon(show ? 'eye-off' : 'eye');
    inp.focus();
  });
}
